var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Holds the configuration of swimlane settings in kanban board.
 */
export class SwimlaneSettings extends ChildProperty {
}
__decorate([
    Property()
], SwimlaneSettings.prototype, "keyField", void 0);
__decorate([
    Property()
], SwimlaneSettings.prototype, "textField", void 0);
__decorate([
    Property(false)
], SwimlaneSettings.prototype, "showEmptyRow", void 0);
__decorate([
    Property(true)
], SwimlaneSettings.prototype, "showItemCount", void 0);
__decorate([
    Property(false)
], SwimlaneSettings.prototype, "allowDragAndDrop", void 0);
__decorate([
    Property()
], SwimlaneSettings.prototype, "template", void 0);
__decorate([
    Property('Ascending')
], SwimlaneSettings.prototype, "sortDirection", void 0);
__decorate([
    Property()
], SwimlaneSettings.prototype, "sortComparer", void 0);
__decorate([
    Property(true)
], SwimlaneSettings.prototype, "showUnassignedRow", void 0);
__decorate([
    Property(false)
], SwimlaneSettings.prototype, "enableFrozenRows", void 0);
